export default "__VITE_ASSET__Bd8ThbGp__"